import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fa4e441"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pc-BillingAddress" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]

import { Row, Col } from "vant";
import { computed } from "vue";
import { country, CA, US } from "@/assets/data/list";
import { getOrder } from "../hooks/order";


export default /*#__PURE__*/_defineComponent({
  __name: 'BillingAddress',
  props: {
  errorField: {
    type: String,
    default: "",
  },
},
  setup(__props) {


const { order } = getOrder();
// US和CA下拉 其余输入

const countryList = country;
// function countryChange(x: Event) {
//   order.Country = (x.target as HTMLSelectElement).value
// }
const isCAxUS = computed(() => {
  return order.Country === "US" || order.Country === "CA";
});
const stateList = computed(() => {
  if (order.Country === "US") return US;
  if (order.Country === "CA") return CA;
  return [];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Row), {
      type: "flex",
      class: "row"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Col), { class: "name" }, {
          default: _withCtx(() => [
            _createTextVNode("Country/Region:")
          ]),
          _: 1
        }),
        _createVNode(_unref(Col), null, {
          default: _withCtx(() => [
            _createVNode(_unref(Row), {
              type: "flex",
              justify: "space-between"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Col), null, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("select", {
                      class: "area-select",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(order).Country) = $event)),
                      name: "CountryShow"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countryList), (country) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: country.value,
                          value: country.value
                        }, _toDisplayString(country.label), 9, _hoisted_2))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _unref(order).Country]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Col), null, {
                  default: _withCtx(() => [
                    _createElementVNode("input", {
                      class: _normalizeClass(["mini-input", { err: __props.errorField === 'Country' }]),
                      value: _unref(order).Country,
                      disabled: "",
                      name: "Country"
                    }, null, 10, _hoisted_3)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(Row), {
      type: "flex",
      class: "row"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Col), { class: "name" }, {
          default: _withCtx(() => [
            _createTextVNode("BillingAddress:")
          ]),
          _: 1
        }),
        _createVNode(_unref(Col), null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(order).Address) = $event)),
              name: "Address",
              class: _normalizeClass({ err: __props.errorField === 'Address' })
            }, null, 2), [
              [_vModelText, _unref(order).Address]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(Row), {
      type: "flex",
      class: "row"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Col), { class: "name" }, {
          default: _withCtx(() => [
            _createTextVNode("BillingCity:")
          ]),
          _: 1
        }),
        _createVNode(_unref(Col), null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(order).City) = $event)),
              name: "City",
              class: _normalizeClass({ err: __props.errorField === 'City' })
            }, null, 2), [
              [_vModelText, _unref(order).City]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(Row), {
      type: "flex",
      class: "row"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Col), { class: "name" }, {
          default: _withCtx(() => [
            _createTextVNode("BillingState:")
          ]),
          _: 1
        }),
        _createVNode(_unref(Col), null, {
          default: _withCtx(() => [
            (_unref(isCAxUS))
              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                  key: 0,
                  class: _normalizeClass(["state-select", { err: __props.errorField === 'State' }]),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(order).State) = $event)),
                  name: "State"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stateList), (state) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: state.value
                    }, _toDisplayString(state.value), 1))
                  }), 128))
                ], 2)), [
                  [_vModelSelect, _unref(order).State]
                ])
              : _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 1,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(order).State) = $event)),
                  name: "State",
                  class: _normalizeClass({ err: __props.errorField === 'State' })
                }, null, 2)), [
                  [_vModelText, _unref(order).State]
                ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(Row), {
      type: "flex",
      class: "row"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Col), { class: "name" }, {
          default: _withCtx(() => [
            _createTextVNode("ZipCode:")
          ]),
          _: 1
        }),
        _createVNode(_unref(Col), null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(order).Zip) = $event)),
              name: "Zip",
              class: _normalizeClass({ err: __props.errorField === 'Zip' })
            }, null, 2), [
              [_vModelText, _unref(order).Zip]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(Row), {
      type: "flex",
      class: "row"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Col), { class: "name" }, {
          default: _withCtx(() => [
            _createTextVNode("Email:")
          ]),
          _: 1
        }),
        _createVNode(_unref(Col), null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(order).Email) = $event)),
              name: "Email",
              class: _normalizeClass({ err: __props.errorField === 'Email' })
            }, null, 2), [
              [_vModelText, _unref(order).Email]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(Row), {
      type: "flex",
      class: "row"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Col), { class: "name" }, {
          default: _withCtx(() => [
            _createTextVNode("Phone:")
          ]),
          _: 1
        }),
        _createVNode(_unref(Col), null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(order).Phone) = $event)),
              name: "Phone",
              class: _normalizeClass({ err: __props.errorField === 'Phone' })
            }, null, 2), [
              [_vModelText, _unref(order).Phone]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})